import { render } from "./AnswersQuestions.vue?vue&type=template&id=19fe8610"
import script from "./AnswersQuestions.vue?vue&type=script&lang=js"
export * from "./AnswersQuestions.vue?vue&type=script&lang=js"

import "./AnswersQuestions.vue?vue&type=style&index=0&id=19fe8610&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__